import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [modo, setModo]       = useState('admin'); // 'admin' | 'barbero'
  const [email, setEmail]     = useState('');
  const [password, setPass]   = useState('');
  const [cedula, setCedula]   = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const cambiarModo = m => { setModo(m); setError(''); };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const payload = modo === 'barbero'
        ? { cedula: cedula.trim() }
        : { email: email.trim(), password };
      const user = await login(payload);
      if (user.role === 'super_admin')  navigate('/superadmin');
      else if (user.role === 'barbero') navigate('/barber/calendar');
      else                              navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = modo === 'barbero'
    ? cedula.length >= 5
    : email.length > 3 && password.length >= 4;

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <div className="login-logo-icon">💈</div>
          <h2 style={{ fontFamily: 'var(--font-display)', marginBottom: 4 }}>BarberSaaS</h2>
          <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)' }}>
            Plataforma de gestión para barberías
          </p>
        </div>

        {/* Tabs */}
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          background: 'var(--color-bg-secondary, #f1f5f9)',
          borderRadius: 10, padding: 4, marginBottom: 22, gap: 4,
        }}>
          {[
            { key: 'admin',   label: '🔐 Administrador' },
            { key: 'barbero', label: '✂️ Barbero' },
          ].map(t => (
            <button
              key={t.key}
              type="button"
              onClick={() => cambiarModo(t.key)}
              style={{
                padding: '9px 0',
                borderRadius: 7,
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.8rem',
                fontWeight: 600,
                transition: 'all .18s',
                background: modo === t.key ? '#fff' : 'transparent',
                color:      modo === t.key ? 'var(--color-primary, #2563eb)' : 'var(--color-text-muted)',
                boxShadow:  modo === t.key ? '0 1px 4px rgba(0,0,0,.1)' : 'none',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Error */}
        {error && (
          <div className="alert alert-error" style={{ marginBottom: 16 }}>⚠️ {error}</div>
        )}

        {/* Formulario */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          {modo === 'admin' ? (
            <>
              <div className="form-group">
                <label className="form-label">Correo electrónico</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="admin@barberia.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoFocus
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Contraseña</label>
                <input
                  type="password"
                  className="form-input"
                  placeholder="••••••••"
                  value={password}
                  onChange={e => setPass(e.target.value)}
                  required
                />
              </div>
            </>
          ) : (
            <div className="form-group">
              <label className="form-label">Número de cédula</label>
              <input
                type="text"
                className="form-input"
                placeholder="Ej: 1234567890"
                value={cedula}
                onChange={e => setCedula(e.target.value.replace(/\D/g, ''))}
                maxLength={15}
                inputMode="numeric"
                autoFocus
                required
              />
              <span style={{ fontSize: '0.72rem', color: 'var(--color-text-muted)', marginTop: 4, display: 'block' }}>
                Ingresa tu cédula para acceder al sistema
              </span>
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-lg w-full"
            disabled={loading || !canSubmit}
            style={{ marginTop: 4 }}
          >
            {loading ? <><div className="spinner" />Verificando...</> : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
